import {Evaluator, registerNode} from "@cm/graph-v2-final"
import {TextureType} from "@generated"
import {
    AnyImageOpContext,
    AnyImageOpResult,
    ImageOpOutputs,
    ValueOrNode,
} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/image-op-node"
import {ImageOpNodeRotateVectorMap} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/composite/rotate-vector-map/node"
import {ImageOpNodeRotateAngleMap} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/composite/rotate-angle-map/node"
import {definition} from "@app/textures/texture-editor/operator-stack/image-op-system/image-op-nodes/composite/rotate-texture-type/definition"
import {ImageOpNodeBag} from "@app/textures/texture-editor/operator-stack/image-op-system/helpers/image-op-node-bag"
import {CompositeImageOpNode} from "@app/textures/texture-editor/operator-stack/image-op-system/detail/abstract/node/composite-image-op-node"

@registerNode
export class ImageOpNodeRotateTextureType extends CompositeImageOpNode<typeof definition> {
    static nodeClass = "ImageOpNodeRotateTextureType"
    static definition = definition

    override async execute(evaluator: Evaluator<AnyImageOpContext>, imageOpNodeBag: ImageOpNodeBag): Promise<ImageOpOutputs<typeof definition>> {
        const {sourceImage, textureType, angleInDegrees} = await evaluator.getAll(this.parameters)

        let resultImage: ValueOrNode<AnyImageOpResult> = sourceImage
        // normal and anisotropy map correction
        if (textureType === TextureType.Normal) {
            // normal maps need to be rotated as well to keep consistent
            resultImage = imageOpNodeBag.getNode("rotateNormalMap", ImageOpNodeRotateVectorMap, {
                sourceImage: resultImage,
                angleInDegrees: angleInDegrees,
                angleFactor: -1,
            }) // we need to rotate the opposite direction
        } else if (textureType === TextureType.Anisotropy) {
            // anisotropy maps need to be rotated as well to keep consistent
            resultImage = imageOpNodeBag.getNode("rotateAnisotropyMap", ImageOpNodeRotateVectorMap, {
                sourceImage: resultImage,
                angleInDegrees: angleInDegrees,
                angleFactor: 2,
            }) // we need to rotate by twice the angle because anisotropy is periodic in 180° (reversed winding)
        } else if (textureType === TextureType.AnisotropyRotation) {
            // anisotropy rotation map need to be rotated as well to keep consistent
            resultImage = imageOpNodeBag.getNode("rotateAnisotropyRotation", ImageOpNodeRotateAngleMap, {
                sourceImage: resultImage,
                angleInDegrees: angleInDegrees,
                angleFactor: -1,
            }) // anisotropy is periodic in 180° but the map stores only 0..0.5 range
        }

        return await evaluator.get(resultImage)
    }
}
